import { createFileRoute, Link, Outlet, useLocation } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/app/labor")({ component: LaborLayout });

const TABS: ReadonlyArray<{ to: string; label: string; exact?: boolean }> = [
  { to: "/app/labor", label: "Overview", exact: true },
  { to: "/app/labor/incentives", label: "Incentives" },
  { to: "/app/labor/rates", label: "Cost Rates" },
];

function LaborLayout() {
  const loc = useLocation();
  return (
    <>
      <div className="border-b bg-card">
        <div className="px-4 sm:px-6 pt-3 flex items-center gap-1 overflow-x-auto">
          {TABS.map((t) => {
            const active = t.exact ? loc.pathname === t.to : loc.pathname.startsWith(t.to);
            return (
              <Link key={t.to} to={t.to as never}
                className={cn(
                  "px-3 py-2 text-sm rounded-t border-b-2 -mb-px",
                  active ? "border-primary text-foreground" : "border-transparent text-muted-foreground hover:text-foreground",
                )}>
                {t.label}
              </Link>
            );
          })}
        </div>
      </div>
      <Outlet />
    </>
  );
}